import Vue from 'vue';
import Vuex from 'vuex';
const moment = require('moment'); // require

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loading: false,
        currentTime: moment()
    },
    getters: {
        getLoadingScreen: state => state.loading,
        getCurrentTimeMoment: state => state.currentTime,
    },
    mutations: {
        setLoading(state, payload) {
            state.loading = payload;
        },
        setCurrentTime(state, payload) {
            state.currentTime = payload;
            state.nextDay = state.currentTime.clone().add(1, 'day');
        }
    },
    actions: {},
    modules: {},
    plugins: []
});
